import {
    buildSchema,
} from "@camberi/firecms";


const categorySchema = buildSchema({
    name: "Categories",
    properties: {
        title: {
            dataType: "string",
            title: "Name",
            description: "Enter category name.",
            validation: {
                required: true,
                requiredMessage: "Category name is required.",
                
            },
        },

        slug: {
            dataType: "string",
            title: "Slug",
            description:"This field will be automatically filled",
            disabled: true,
            // validation: {
            //     required: true
            // }
            
        },
        order: {
            dataType: "number",
            title: "Order",
            description: "App displays categories according to order value",
            validation: {
                required: true,
                positive:true,
                integer:true,
            }
        },
        updated_at: {
            dataType: "timestamp",
            title: "Updated_at",
            autoValue: "on_update",
            description: "This field will be automatically filled."
        },

        file: {
            title: "File",
            dataType: "string",
            description: "Enter an image for this category",
            config: {
                storageMeta: {
                    mediaType: "image",
                    storagePath: "images",
                    acceptedFiles: ["image/*"],
                    storeUrl:true
                }
            },
            validation :{
required: true
            }
        },
        publish: {
            dataType: "boolean",
            title: "Publish",
            validation: {
                required: true
            }
        },
    }
});


categorySchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};
export default categorySchema;